export const getSessionStorageItem = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

/**
 * 寫入 sessionStorage；失敗時回傳 false，避免呼叫端因例外中斷流程。
 * @external https://innotech.atlassian.net/browse/IN-144178 - 新增安全的 sessionStorage set，供 Passkey pending redirect 使用
 */
export const setSessionStorageItem = (key: string, value: string): boolean => {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

/**
 * 移除 sessionStorage 項目；存取失敗時忽略，避免例外影響主流程。
 * @external https://innotech.atlassian.net/browse/IN-144178 - 新增安全的 sessionStorage remove，供 Passkey pending redirect 清除
 */
export const removeSessionStorageItem = (key: string): void => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore storage access failures
  }
};
